import { render } from "./OverlayLarge.vue?vue&type=template&id=c4c8d030&scoped=true"
import script from "./OverlayLarge.vue?vue&type=script&lang=js"
export * from "./OverlayLarge.vue?vue&type=script&lang=js"

import "./OverlayLarge.vue?vue&type=style&index=0&id=c4c8d030&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4c8d030"]])

export default __exports__